export default __webpack_public_path__ + "static/media/national georgaphic.5f7cadd7.webp";